import { render, staticRenderFns } from "./AddDeliveryBoy.vue?vue&type=template&id=6bfd6f74&"
import script from "./AddDeliveryBoy.vue?vue&type=script&lang=js&"
export * from "./AddDeliveryBoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports